import React from 'react';
import clsx from 'clsx';

import { UICarbonNumberField } from '@futrli/ui-components';

import headerStyles from '../../prediction-header-bar/prediction-header-bar.scss';

interface IncreaseDecreaseAmountProps {
  currencySymbol: string;
  disabled?: boolean;
  onChange: (value: string) => void;
  value: string;
}

export const IncreaseDecreaseAmount = ({ currencySymbol, disabled, onChange, value }: IncreaseDecreaseAmountProps) => (
  <UICarbonNumberField
    type="currency"
    currencySymbol={currencySymbol}
    className={clsx(headerStyles.formInput, headerStyles.unlabelledControl)}
    disabled={disabled}
    onChange={onChange}
    value={value}
    size="large"
  />
);
